import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

export const mapSettingsPlacesSearchesSelector = (state: AppState) => state.map.mapSettings.data.places.searches;
export const useMapSettingsPlacesSearchesSelector = () => useSelector(mapSettingsPlacesSearchesSelector);
